<template>
  <div class="row">
    <div class="col-12">
      <h2 class="bp_color text-uppercase">Genius Money Company Information</h2>
    </div>

    <div class="col-12">
      <b-card header="Genius Team" header-tag="h4" body-class="mb-3 record_card_body">
        <div class="row">
          <div class="col-12">
            <p>Your primary point of contact within the Genius team is:<br>
              <strong v-if="notEmptyObject(company) && company.primary_consultant_id !== null">{{ company.primary_consultant.first_name }}
                {{ company.primary_consultant.surname }}</strong>.
            </p>
            <p>Contact them on <a class="bp_color" href="tel:+443303350400">0330 3350400</a> for any questions or queries.</p>

            <p class="mb-0">Below you will find all of the information on the Genius Company you are trading with. Use the information below to to verify our company with HMRC and
              process your payments to us.</p>
          </div>
        </div>
      </b-card>
    </div>

    <div class="col-xl-6" v-if="notEmptyObject(payment_process_info) && payment_process_info.payroll_trading_company === 'Genius Contracts Limited'">
      <b-card header="Genius Contracts Limited" header-tag="h4" body-class="mb-3 record_card_body">
        <div class="row">
          <div class="col-xl-5"><strong>Company Number:</strong></div>
          <div class="col-xl-7">10784415</div>
          <div class="col-xl-5"><strong>Registered Address:</strong></div>
          <div class="col-xl-7">4 Old Park Lane, Mayfair, London, England, W1K 1QW</div>
          <div class="col-xl-5"><strong>Incorporated On:</strong></div>
          <div class="col-xl-7">23 May 2017</div>
          <div class="col-12">&nbsp;</div>
          <div class="col-xl-5"><strong>View on Companies House:</strong></div>
          <div class="col-xl-7">
            <a class="bp_color" href="https://find-and-update.company-information.service.gov.uk/company/10784415" target="_blank">Genius Contracts Limited</a>
          </div>
          <div class="col-12">&nbsp;</div>
          <div class="col-12">
            <h5 class="bp_color">Company Certificates</h5>
          </div>
          <div class="col-xl-5"><strong>Incorporation</strong></div>
          <div class="col-xl-7">
            <a class="bp_color" href="https://geniusmoney.co.uk/docs/contracts/Contracts_Certificate_of_Incorporation.pdf" target="_blank">View Certificate</a>
          </div>
          <div class="col-xl-5"><strong>VAT Registration</strong></div>
          <div class="col-xl-7">
            <a class="bp_color" href="https://geniusmoney.co.uk/docs/contracts/Contracts_Certificate_of_Registration_VAT.pdf" target="_blank">View Certificate</a>
          </div>
          <div class="col-xl-5"><strong>Certifying Document</strong></div>
          <div class="col-xl-7"><a class="bp_color" href="https://geniusmoney.co.uk/docs/contracts/Contracts_Certifying_Document.pdf" target="_blank">View Document</a></div>
        </div>
      </b-card>
    </div>
    <div class="col-xl-6" v-if="notEmptyObject(payment_process_info) && payment_process_info.payroll_trading_company === 'Genius Payroll Limited'">
      <b-card header="Genius Payroll Limited" header-tag="h4" body-class="mb-3 record_card_body">
        <div class="row">
          <div class="col-12">
            <div class="row">
              <div class="col-xl-5"><strong>Company Number:</strong></div>
              <div class="col-xl-7">07439295</div>
              <div class="col-xl-5"><strong>Registered Address:</strong></div>
              <div class="col-xl-7">4 Old Park Lane, Mayfair, London, England, W1K 1QW</div>
              <div class="col-xl-5"><strong>Incorporated On:</strong></div>
              <div class="col-xl-7">15 November 2010</div>
              <div class="col-12">&nbsp;</div>
              <div class="col-xl-5"><strong>View on Companies House:</strong></div>
              <div class="col-xl-7">
                <a class="bp_color" href="https://find-and-update.company-information.service.gov.uk/company/07439295" target="_blank">Genius Contracts Limited</a>
              </div>
              <div class="col-12">&nbsp;</div>
              <div class="col-12">
                <h5 class="bp_color">Company Certificates</h5>
              </div>
              <div class="col-xl-5"><strong>Incorporation</strong></div>
              <div class="col-xl-7">
                <a class="bp_color" href="https://geniusmoney.co.uk/docs/payroll/Payroll_Certificate_of_Incorporation.pdf" target="_blank">View Certificate</a>
              </div>
              <div class="col-xl-5"><strong>VAT Registration</strong></div>
              <div class="col-xl-7">
                <a class="bp_color" href="https://geniusmoney.co.uk/docs/payroll/Payroll_Certificate_of_Registration_VAT.pdf" target="_blank">View Certificate</a>
              </div>
              <div class="col-xl-5"><strong>Certifying Document</strong></div>
              <div class="col-xl-7"><a class="bp_color" href="https://geniusmoney.co.uk/docs/payroll/Payroll_Certifying_Document.pdf" target="_blank">View Document</a></div>
            </div>
          </div>
        </div>
      </b-card>
    </div>

    <div class="col-xl-6">
      <b-card header="EMPLOYERS LIABILITY INSURANCE" header-tag="h4" body-class="mb-3 record_card_body">
        <div class="row">
          <div class="col-12">
            <h5>Please click the link to view a copy of our Employers Liability Insurance Certificate.</h5>
            <p class="mb-0"><a class="bp_color" href="https://geniusmoney.co.uk/docs/Certificate_of_Employers_Liability_Insurance.pdf" target="_blank">View Certificate</a></p>
          </div>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
export default {
  name: "c_genius",
  data() {
    return {
      company: {},
      payment_process_info: {}
    }
  },
  beforeMount() {
    axios.get(this.crmApiPath + 'contact/' + this.$store.state.auth.me.contact_id + '/company/show').then(client_id => {
      this.client_id = client_id.data.id;
      axios.get(this.crmApiPath + 'company/' + this.client_id).then(company => {
        this.company = company.data;

        axios.get(this.crmApiPath + 'company/payment_process_info/company/' + this.client_id).then(payment_process_info => {
          this.payment_process_info = payment_process_info.data;
          if (this.notEmptyObject(payment_process_info.data) && payment_process_info.data.payroll_trading_company_id !== null) {
            this.payment_process_info.payroll_trading_company = this.$store.state.crm_options.payroll_trading_company.find(tc => tc.id === payment_process_info.data.payroll_trading_company_id).value
          }
        })
      });
    });
  }
}
</script>
